module.exports = __webpack_public_path__ + "img/signature_yellow.d5c841dc.png";